<header class="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- ====== ROW 1: Logo + Desktop Center + Right Nav ====== -->
    <div class="flex items-center justify-between h-16 md:h-20">
      <!-- Left: Logo -->
      <div class="flex items-center flex-shrink-0">
        <a routerLink="/" class="flex items-center">
          <img src="assets/img/capitalFoodLogo.webp" class="w-24 h-12 md:w-28 md:h-14 rounded-md" alt="Capital Food">
        </a>

        <!-- Desktop Center: Delivery Address (hidden on mobile) -->
        <div class="hidden md:flex items-center ml-4 lg:ml-8 flex-shrink-0">
          <div (click)="openStorePickupDialogCustom('delivery')"
            class="flex items-center bg-gray-50 rounded-full px-3 py-1.5 lg:px-4 lg:py-2 border border-gray-200 min-w-[200px] lg:min-w-[280px] cursor-pointer hover:bg-gray-100 transition-colors">
            <lucide-icon name="truck" [size]="16" class="flex-shrink-0 text-orange-500 mr-1.5"></lucide-icon>
            <small class="text-[13px] truncate"
              [style.color]="lastDeliveryAddress ? '#4b5563' : '#e85d3a'"
              [style.font-weight]="lastDeliveryAddress ? '400' : '600'">
              {{
                lastDeliveryAddress
                  ? (lastDeliveryAddress?.shippingPlotNo || '') +
                    (lastDeliveryAddress?.shippingAddress ? ', ' + lastDeliveryAddress?.shippingAddress : '') +
                    (lastDeliveryAddress?.cityName ? ', ' + lastDeliveryAddress?.cityName : '') +
                    (lastDeliveryAddress?.stateName ? ', ' + lastDeliveryAddress?.stateName : '') +
                    (lastDeliveryAddress?.shippingPinCode ? ', ' + lastDeliveryAddress?.shippingPinCode : '')
                  : '📍 Where to deliver?'
              }}
            </small>
          </div>
        </div>
      </div>

      <!-- Right: Desktop Navigation (hidden on mobile) -->
      <nav class="hidden md:flex items-center justify-end gap-2 lg:gap-6 whitespace-nowrap flex-shrink-0">
        <!-- Bulk Order -->
        <!-- <a routerLink="/offers"
          class="flex items-center text-[10px] lg:text-sm font-medium text-gray-600 hover:text-orange-500 transition-colors">
          <lucide-icon name="gift" class="w-4 h-4 mr-1"></lucide-icon>
          Bulk Order
        </a> -->

        <!-- Cart -->
        <a routerLink="/cart"
          class="flex items-center text-sm font-medium text-gray-600 hover:text-orange-500 transition-colors relative">
          <lucide-icon name="shopping-cart" class="w-5 h-5 mr-1"></lucide-icon>
          Cart
          <span *ngIf="cartCount > 0"
            class="ml-0.5 text-[10px] lg:text-sm font-medium text-gray-600 absolute -top-2 -right-2 bg-orange-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
            {{ cartCount }}
          </span>
        </a>

        <!-- Sign In / Profile Dropdown -->
        <button *ngIf="showSignIn == true"
          class="rounded-full bg-orange-500 hover:bg-orange-600 text-white px-3 lg:px-4 py-1.5 lg:py-2 text-[10px] lg:text-sm font-medium transition-all"
          (click)="loginClick()">
          Sign in
        </button>

        <div *ngIf="!showSignIn" class="relative">
          <button (click)="isMenuOpen = !isMenuOpen"
            class="flex items-center space-x-1 p-1 pr-2 lg:pr-3 rounded-full hover:bg-gray-100 transition-all border border-transparent hover:border-gray-200">
            <div class="w-7 h-7 lg:w-8 lg:h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold text-xs">
              {{ name | slice:0:1 | uppercase }}
            </div>
            <span class="text-[10px] lg:text-sm font-semibold text-gray-700 max-w-[60px] truncate">{{ name }}</span>
            <lucide-icon [name]="isMenuOpen ? 'chevron-up' : 'chevron-down'"
              class="w-4 h-4 text-gray-400"></lucide-icon>
          </button>

          <!-- Dropdown -->
          <div *ngIf="isMenuOpen" (clickOutside)="isMenuOpen = false"
            class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 py-2 z-50">
            <p class="px-4 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Account Settings</p>
            <a [routerLink]="['/profile']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="user" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Profile
            </a>
            <a [routerLink]="['/order-history']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="history" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Order history
            </a>
            <a [routerLink]="['/payment-history']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="history" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Payment history
            </a>
            <div class="my-2 border-t border-gray-100"></div>
            <button (click)="logout(false); isMenuOpen = false"
              class="w-full flex items-center px-4 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors">
              <lucide-icon name="log-out" class="w-4 h-4 mr-3"></lucide-icon> Logout
            </button>
          </div>
        </div>
        <div *ngIf="isMenuOpen" class="fixed inset-0 z-40" (click)="isMenuOpen = false"></div>
      </nav>

      <!-- ====== MOBILE: Right Icons (visible only below md) ====== -->
      <div class="flex md:hidden items-center gap-2 flex-shrink-0">
        <!-- Bulk Order (mobile) -->
        <!-- <a routerLink="/offers" class="flex items-center text-xs text-gray-600 hover:text-orange-500 transition-colors">
          <lucide-icon name="gift" class="w-5 h-5"></lucide-icon>
          Bulk Order
        </a> -->

        <!-- Cart (mobile) -->
        <a routerLink="/cart" class="flex items-center text-gray-600 hover:text-orange-500 transition-colors relative">
          <lucide-icon name="shopping-cart" class="w-5 h-5"></lucide-icon>
          <span *ngIf="cartCount > 0" class="ml-0.5 text-xs font-medium text-gray-600 absolute -top-2 -right-2 bg-orange-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
            {{ cartCount }}
          </span>
        </a>

        <!-- Profile / Sign In (mobile) -->
        <button *ngIf="showSignIn == true"
          class="rounded-full bg-orange-500 hover:bg-orange-600 text-white px-3 py-1.5 text-xs font-medium transition-all"
          (click)="loginClick()">
          Sign in
        </button>

        <div *ngIf="!showSignIn" class="relative">
          <button (click)="isMenuOpen = !isMenuOpen"
            class="flex items-center space-x-1 p-1 rounded-full hover:bg-gray-100 transition-all border border-transparent hover:border-gray-200">
            <div class="w-7 h-7 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold text-xs">
              {{ name | slice:0:1 | uppercase }}
            </div>
            <lucide-icon [name]="isMenuOpen ? 'chevron-up' : 'chevron-down'" class="w-4 h-4 text-gray-400"></lucide-icon>
          </button>
          <!-- same dropdown for mobile -->
          <div *ngIf="isMenuOpen" (clickOutside)="isMenuOpen = false"
            class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 py-2 z-50">
            <p class="px-4 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Account Settings</p>
            <a [routerLink]="['/profile']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="user" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Profile
            </a>
            <a [routerLink]="['/order-history']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="history" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Order history
            </a>
            <a [routerLink]="['/payment-history']" (click)="isMenuOpen = false"
              class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors">
              <lucide-icon name="history" class="w-4 h-4 mr-3 opacity-70"></lucide-icon> Payment history
            </a>
            <div class="my-2 border-t border-gray-100"></div>
            <button (click)="logout(false); isMenuOpen = false"
              class="w-full flex items-center px-4 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors">
              <lucide-icon name="log-out" class="w-4 h-4 mr-3"></lucide-icon> Logout
            </button>
          </div>
          <div *ngIf="isMenuOpen" class="fixed inset-0 z-40" (click)="isMenuOpen = false"></div>
        </div>
      </div>
    </div>

    <!-- ====== ROW 2: Mobile Delivery Address (full-width, below md only) ====== -->
    <div class="block md:hidden pb-2.5">
      <div (click)="openStorePickupDialogCustom('delivery')"
        class="flex items-center bg-gray-50 rounded-full px-4 py-2 border border-gray-200 w-full cursor-pointer hover:bg-gray-100 transition-colors">
        <lucide-icon name="truck" [size]="16" class="flex-shrink-0 text-orange-500 mr-2"></lucide-icon>
        <small class="text-[12px] truncate flex-1"
          [style.color]="lastDeliveryAddress ? '#4b5563' : '#e85d3a'"
          [style.font-weight]="lastDeliveryAddress ? '400' : '600'">
          {{
            lastDeliveryAddress
              ? (lastDeliveryAddress?.shippingPlotNo || '') +
                (lastDeliveryAddress?.shippingAddress ? ', ' + lastDeliveryAddress?.shippingAddress : '') +
                (lastDeliveryAddress?.cityName ? ', ' + lastDeliveryAddress?.cityName : '') +
                (lastDeliveryAddress?.stateName ? ', ' + lastDeliveryAddress?.stateName : '') +
                (lastDeliveryAddress?.shippingPinCode ? ', ' + lastDeliveryAddress?.shippingPinCode : '')
              : '📍 Where to deliver?'
          }}
        </small>
      </div>
    </div>
  </div>
</header>